// Amplify auth Hub event names.
//
// Amplify v4/v5 dispatched `signIn` / `signOut`. Amplify v6 renamed these to
// `signedIn` / `signedOut` (see `@aws-amplify/core` AuthTypes and
// `dispatchSignedInHubEvent` in `@aws-amplify/auth`). Nothing in v6 emits the
// old names.
//
// `Hub.listen` is untyped at runtime, so a listener registered for an event
// name that no longer exists never fires and never errors — it just silently
// does nothing. That is exactly how the post-login redirect broke: `_app.js`
// still listened for `signIn`, so the reload that re-runs `getServerSideProps`
// on `/` (the only thing that sends an authenticated user to
// `/valuation/list`) never happened, and users sat on a LoadingShell forever.
//
// Keeping the v5 names in these lists is harmless and guards against a
// downgrade or a mixed-version dependency tree.

const SIGNED_IN_EVENTS = ['signedIn', 'signIn', 'signInWithRedirect'];
const SIGNED_OUT_EVENTS = ['signedOut', 'signOut'];

export const isSignedInEvent = (event) => SIGNED_IN_EVENTS.includes(event);

export const isSignedOutEvent = (event) => SIGNED_OUT_EVENTS.includes(event);
